import MDBox from "components/MDBox";
import { ETypeContent } from "../content.type";
import ContentUpdateHousing from "./content-update-housing";

function SectionHebergement(): JSX.Element {
  return (
    <MDBox>
      <ContentUpdateHousing
        title="Hébergement"
        typeContent={ETypeContent.hebergement}
      />
    </MDBox>
  );
}

export default SectionHebergement;
